import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../components/Loading";
import { api } from "../../services/api";
/* import { withAuthenticationRequired } from "@auth0/auth0-react"; */
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { MensajeFinalizarCreacionEvento } from "../../components/modales/MensajeFinalizarCreacionEvento";
import { MoreVert, TableChart, Search, Add, OpenInNew, KeyboardBackspace, CalendarMonthOutlined, Lock, LockOpen, InsertChartOutlinedOutlined, DeleteForeverOutlined, ArrowBack, FilterList, CheckCircleOutline } from '@mui/icons-material'
import {
  Container, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert, Select, MenuItem,
  IconButton, Menu, ListItemIcon, ListItemText, InputAdornment,
  TextField, Divider, CircularProgress, Chip, Avatar, Drawer, Box, Fab, Pagination,
  Dialog,
  Tooltip,
  Typography
} from '@mui/material';
import { usePlanesValidacion } from "../../hooks/usePlanesValidacion";
import { fechaEventoTexto } from "../../utils/evento";
import { toast } from "react-toastify";
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";

export const Evento = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const { t } = useTranslation("global");
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [filtroEventos, setFiltroEventos] = useState("Activo");
  const [open, setOpen] = useState(false);
  const [eventoId, setEventoId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElID, setAnchorElID] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [totalLength, setTotalLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const { validarCrearEvento, validando } = usePlanesValidacion();

  const [openConfirm, setOpenConfirm] = useState(false);
  const [eventoToDelete, setEventoToDelete] = useState(null);
  const [actionType, setActionType] = useState("");

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
    if (!newOpen) {
      setFiltroEventos("Activo");
      setQuery("");
    }
  };

  const notify = (type, message, position = "bottom-center") => {
    const options = {
      position,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      case 'info':
        toast.info(message, options);
        break;
      case 'warning':
        toast.warning(message, options);
        break;
      default:
        toast(message, options);
    }
  };

  const handleOpen = (id) => {
    setEventoId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setEventoId(null);
    setOpen(false);
  };

  const handleClickSeeMore = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setAnchorElID(e.currentTarget.id);
  };

  const handleCloseSeeMore = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
    setAnchorElID(null);
  };

  const openSeeMore = Boolean(anchorEl);
  const ITEM_HEIGHT = 48

  const handleDeleteEvento = (e, evento) => {
    if (e) e.stopPropagation();

    const callApi = async () => {
      try {
        const response = await api.eventos.deleteEvento(evento.id);
        if (response.status === "success") {
          toast.success("El evento se elimino correctamente", {
            position: "top-center",
            autoClose: 3000,
          });
          setData((prev) => prev.filter((ev) => ev.id !== evento.id));
        }
      } catch (error) {
        toast.error("Error al eliminar el evento", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    };

    callApi();
  };

  const handleFinishEvento = (e, evento) => {
    if (e) e.stopPropagation();

    const callApi = async () => {
      try {
        const response = await api.eventos.finishEvento(evento.id);
        if (response.status === "success") {
          toast.success("El evento se finalizó correctamente", {
            position: "top-center",
            autoClose: 3000,
          });
          setData((prev) =>
            prev.map((ev) =>
              ev.id === evento.id
                ? {
                    ...ev,
                    id_estados_eventos: 4,
                    estado: { ...ev.estado, id: 4, estado: "Finalizado" },
                  }
                : ev,
            ),
          );
        }
      } catch (error) {
        toast.error("Error al finalizar el evento", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    };

    callApi();
  };

  // el reporte general es de ventas: sólo owner y cliente (el backend lo exige)
  const puedeVerReportes = (evento) => evento.rol === "Owner" || evento.rol === "Cliente";

  const HandleDownloadReport = (e, evento) => {
    e.stopPropagation();

    const callApi = async (e) => {
      try {
        const response = await api.reporte.downloadReporte(evento.id);
        if (!response) {
          notify("error", "Error al realizar la descarga");
          throw new Error("Error al descargar el Excel");
        }
        const blob = await response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Reporte-${evento.id}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        setAnchorElID(null);

        notify("success", "La descarga se realizó con éxito");
      } catch (error) {
        console.error("Error al descargar el Excel:", error.message);
        throw error;
      }
    };
    callApi();
  };

  const handleConfirmAction = () => {
    if (actionType === "delete") {
      handleDeleteEvento(null, eventoToDelete);
    } else if (actionType === "finish") {
      handleFinishEvento(null, eventoToDelete);
    }
    setOpenConfirm(false);
    setActionType("");
    setEventoToDelete(null);
  };

  useEffect(() => {
    const callApi = async () => {
      setLoading(true);

      try {
        const response = await api.eventos.getAll(query, pageSize, currentPage, filtroEventos);

        if (response.status === "success") {
          setData(response.data.eventos);
          setTotalLength(response.data.totalDataSize);
        }
      } catch (error) {
        toast.error("Error en la red.", {
          position: "top-center",
          autoClose: 4000,
        });
      } finally {
        setLoading(false);
      }
    };

    callApi();
  }, [query, pageSize, currentPage, filtroEventos]);

  /*  useEffect(() => {
     let filtro = data;
 
     if (filtroEventos !== "Todo") {
       filtro = filtro?.filter((evento) =>
         evento?.estado?.estado === filtroEventos
       )
     }
 
     setEventosFiltrados(filtro);
   }, [filtroEventos, data]); */

  const handleRowClick = (evento) => {
    history.push("/eventos/" + evento.id);
  };

  const handleCrearEvento = async () => {
    const resultado = await validarCrearEvento();
    if (!resultado.valido) {
      toast.error(resultado.mensaje, { autoClose: 6000 });
      return;
    }
    history.push("/crearEvento/creacion");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setQuery(e.target.q.value);
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleFiltroChange = (nuevoFiltro) => {
    setFiltroEventos(nuevoFiltro);
    setCurrentPage(1);
  };

  const colorCirculo = (estado) => {
    switch (estado) {
      case "Borrador":
        return { relleno: "#FFF2B4", texto: "#827229" };
      case "Activo":
        return { relleno: "#B7FFCC", texto: "#216735" };
      case "Finalizado":
        return { relleno: "#DCDBDD", texto: "#363536" };
      case "Eliminado":
        return { relleno: "#FFB4B4", texto: "#8C2828" };
      default:
        return { relleno: "transparent", texto: "transparent" };
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleGoBack = () => {
    history.push(`/`);
  };

  const renderEvento = (evento) => (
    <div key={evento.id} style={{ marginBottom: '15px' }}
      onClick={evento.estado.id === 1
        ? () => handleOpen(evento.id)
        : evento.estado.id === 3
          ? null
          : () => handleRowClick(evento)}
    >
      <div className="w-100">
        <div className="d-flex align-items-center gap-1 mb-2">
          <p className="m-0" style={{ fontSize: '18px' }}>
            {evento.evento}
          </p>
          {evento.privado
            ?
            <span style={{ color: '#aeaeae' }}>
              <Lock style={{ fontSize: '.8rem' }} />
              <small>{t("event.private")}</small>
            </span>
            :
            <span style={{ color: '#aeaeae' }}>
              <LockOpen style={{ fontSize: '.8rem' }} />
              <small>{t("event.public")}</small>
            </span>
          }
          <IconButton
            aria-label="see more"
            id={evento.id}
            aria-controls={openSeeMore ? 'long-menu' : undefined}
            aria-expanded={openSeeMore ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClickSeeMore}
            sx={{ p: 0 }}
            className="ms-auto"
          >
            <MoreVert />
          </IconButton>
          <Menu
            id={evento.id}
            aria-label="report"
            anchorEl={anchorEl}
            open={evento.id == anchorEl?.id}
            onClose={handleCloseSeeMore}
            slotProps={{
              paper: {
                elevation: 1,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          >
            {puedeVerReportes(evento) && (
            <MenuItem onClick={(e) => HandleDownloadReport(e, evento)}>
              <ListItemIcon>
                <TableChart fontSize="medium" />
              </ListItemIcon>
              <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Reporte general</ListItemText>
            </MenuItem>
            )}
            {evento.rol === "Owner" && evento.id_estados_eventos !== 4 && [
                <Divider key="divider" />,
              ...(evento.id_estados_eventos === 2 ? [
                <MenuItem key="finish" onClick={(e) => {
                          e.stopPropagation();
                          setEventoToDelete(evento);
                  setActionType('finish');
                          setOpenConfirm(true);
                          handleCloseSeeMore(e);
                }}>
                        <ListItemIcon>
                    <CheckCircleOutline fontSize="medium" sx={{ color: "#5656ff" }} />
                        </ListItemIcon>
                  <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Finalizar evento</ListItemText>
                </MenuItem>
              ] : []),
              <MenuItem key="delete" onClick={(e) => {
                    e.stopPropagation();
                    setEventoToDelete(evento);
                setActionType('delete');
                    setOpenConfirm(true);
                    handleCloseSeeMore(e);
              }}>
                  <ListItemIcon>
                  <DeleteForeverOutlined fontSize="medium" sx={{ color: "#dc2626" }} />
                  </ListItemIcon>
                <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Eliminar evento</ListItemText>
              </MenuItem>
              ]}
          </Menu>
        </div>
        <div className="d-flex gap-3">
          <Chip label={evento.estado?.estado} size="small"
            sx={{
              background: colorCirculo(evento.estado.estado).relleno,
              color: colorCirculo(evento.estado.estado).texto,
            }}
          />
          <Chip size="small" sx={{ background: '#DADAFF', color: '#3D2EAB' }}
            avatar={<Avatar sx={{ backgroundColor: '#988EDE' }}><span style={{ color: '#3D2EAB' }}>R</span></Avatar>}
            label={evento.rol.replace('_', ' ')}
          />
        </div>
      </div>
      <Divider sx={{ marginTop: '15px', bgcolor: 'gray' }} />
    </div>
  );

  return (
    <>
      {isMobile ? (
        <Container>
          <div className="py-2">
            <div className="mb-3" /* style={{padding:"25px 35px"}} */>
              <Tooltip title="Volver">
                <IconButton
                  onClick={handleGoBack}
                  size="small"
                  sx={{
                    color: "#5656ff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "4px 12px",
                    "&:hover": {
                      backgroundColor: "rgba(11, 0, 98, 0.04)"
                    }
                  }}
                >
                  <ArrowBack fontSize="small" />
                  <span style={{
                      marginLeft: "4px",
                      fontSize: "14px",
                    fontFamily: "Bricolage Grotesque, serif"
                  }}>
                    Volver
                  </span>
                </IconButton>
              </Tooltip>
            </div>
            <h1 style={{ color: '#0B0062' }}>
              {t("navbar.myEvents")}
            </h1>
            <p>{t("event.controlEvent")}</p>
          </div>
          <div className="d-flex gap-3 mb-4 align-items-center" style={{ width: '100%' }}>
            <TextField
              size="small"
              placeholder="Buscar evento"
              fullWidth
              onClick={toggleDrawer(true)}
              slotProps={{
                input: {
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Select
              id="filtro-eventos"
              IconComponent={() => null}
              value={filtroEventos}
              onChange={(e) => handleFiltroChange(e.target.value)}
              renderValue={() => (
                <IconButton sx={{ padding: "0px" }}>
                  <FilterList size="small" sx={{ padding: "0px" }} />
                </IconButton>
              )}
              sx={{ width: "35%", height: '2.5rem', display: "flex", justifyContent: "center", alignItems: "center", outline: 'none', boxShadow: 'none', }}
            >
              <MenuItem value="Todo">Todos</MenuItem>
              <MenuItem value="Borrador">Borrador</MenuItem>
              <MenuItem value="Activo">Activos</MenuItem>
              {/* <MenuItem value="Eliminado">Eliminados</MenuItem> */}
              <MenuItem value="Finalizado">Finalizados</MenuItem>
            </Select>
          </div>
          <Drawer open={openDrawer} onClose={toggleDrawer(false)} anchor="bottom" >
            <Box sx={{ width: "100%", height: "100vh", p: 2, overflow: 'auto' }}>
              <div className="d-flex align-items-center justify-content-between">
                <h2 className="mb-0">Mis Eventos</h2>
                <KeyboardBackspace onClick={toggleDrawer(false)} />
              </div>
              <form onSubmit={handleSearch} className="mt-2 mb-4">
                <TextField
                  sx={{
                    fontFamily: "Bricolage Grotesque",
                    mb: 2,
                    '& .MuiInputBase-input-MuiOutlinedInput-input': {
                      fontFamily: "Bricolage Grotesque",
                    },
                    '& label.Mui-focused': {
                      color: '#5656FF',
                      fontFamily: "Bricolage Grotesque"
                    },
                    '& .MuiOutlinedInput-root': {
                      height: "30px",

                      '& fieldset': {
                        borderColor: '#B2BAC2',
                      },
                      '&:hover fieldset': {
                        borderColor: '#5656ff',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#5656ff',
                      },
                    }
                  }}
                  id="exampleSearch"
                  name="q"
                  size="small"
                  placeholder="Buscar evento"
                  type="search"
                  fullWidth
                  onClick={toggleDrawer(true)}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </form>
              {data?.length > 0 && query !== "" ? (
                <>
                  <small>Resultados</small>
                  {data.map(renderEvento)}
                </>
              ) : (
                <p>Resultados: 0</p>
              )}
            </Box>
          </Drawer>
          {loading ? (
            <div className="d-flex justify-content-center">
              <CircularProgress />
            </div>
          ) : (
            data?.length > 0 ? (
            data.map(renderEvento)
          ) : (
            <Alert severity="info" color="secondary">
              {filtroEventos !== "Todo"
                ? `Aún no tienes eventos ${filtroEventos.toLowerCase()}s.`
                  : "Aún no tienes eventos."
                }
            </Alert>
            )
          )}
          <div
            style={{
              position: 'fixed',
              bottom: 20,
              right: 20,
              zIndex: 1000
            }}
          >
            <Fab
              aria-label="add"
              onClick={handleCrearEvento}
              disabled={validando}
              sx={{ background: "#5656FF", color: "#fff" }}
            >
              <Add />
            </Fab>
          </div>
          <MensajeFinalizarCreacionEvento open={open} handleClose={handleClose} eventoId={eventoId} />
          <Dialog
            open={openConfirm}
            onClose={() => setOpenConfirm(false)}
            PaperProps={{
              sx: {
                borderRadius: 3,
                minWidth: 340,
                p: 0,
                boxShadow: 6,
              }
            }}
          >
            <Box sx={{ p: 3, textAlign: 'center', position: 'relative' }}>
              <IconButton
                aria-label="close"
                onClick={() => setOpenConfirm(false)}
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  color: (theme) => theme.palette.grey[500],
                }}
                size="small"
              >
                ×
              </IconButton>
              <Box
                sx={{
                  background: actionType === 'delete' ? '#FFF0F0' : '#F0FFF4',
                  borderRadius: '50%',
                  width: 56,
                  height: 56,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                }}
              >
                {actionType === 'delete' ? (
                  <DeleteForeverOutlined sx={{ color: '#dc2626', fontSize: 32 }} />
                ) : (
                  <CheckCircleOutline sx={{ color: '#5656ff', fontSize: 32 }} />
                )}
              </Box>
              <h3 style={{ margin: 0, fontWeight: 600 }}>
                {actionType === 'delete'
                  ? '¿Estás seguro que deseas eliminar este evento?'
                  : '¿Estás seguro que deseas finalizar este evento?'}
              </h3>
              <p style={{ color: '#6C757D', marginTop: 8 }}>
                {actionType === 'delete'
                  ? 'Esta acción es permanente.'
                  : 'El evento cambiará al estado finalizado y no se podrán vender más entradas.'}
              </p>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                <Button
                  onClick={() => setOpenConfirm(false)}
                  variant="outlined"
                  sx={{
                    background: '#fff',
                    color: actionType === 'delete' ? '#dc2626' : '#059669',
                    borderColor: actionType === 'delete' ? '#dc2626' : '#059669',
                    fontWeight: 500,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      background: actionType === 'delete' ? '#fff5f5' : '#f0fff4',
                      borderColor: actionType === 'delete' ? '#dc2626' : '#059669'
                    }
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={handleConfirmAction}
                  variant="contained"
                  sx={{
                    background: actionType === 'delete' ? '#dc2626' : '#059669',
                    color: '#fff',
                    fontWeight: 500,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      background: actionType === 'delete' ? '#b71c1c' : '#047857'
                    }
                  }}
                >
                  {actionType === 'delete' ? 'Eliminar' : 'Finalizar'}
                </Button>
              </Box>
            </Box>
          </Dialog>
        </Container>
      ) : (
        <Container className="my-3" maxWidth="lg">
          <div className="py-2">
            <div className="mb-3" /* style={{padding:"25px 35px"}} */>
              <Tooltip title="Volver">
                <IconButton
                  onClick={handleGoBack}
                  size="small"
                  sx={{
                    color: "#5656ff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "4px 12px",
                    "&:hover": {
                      backgroundColor: "rgba(11, 0, 98, 0.04)"
                    }
                  }}
                >
                  <ArrowBack fontSize="small" />
                  <span style={{
                      marginLeft: "4px",
                      fontSize: "14px",
                    fontFamily: "Bricolage Grotesque, serif"
                  }}>
                    Volver
                  </span>
                </IconButton>
              </Tooltip>
            </div>
            <h1 style={{ color: '#0B0062' }}>
              Mis eventos
            </h1>
            <p className="" style={{ color: "#6C757D", fontStyle: "italic" }}>Acá vas a encontrar todos los eventos que creaste, tanto los que están en curso como los que ya finalizaron. Podés filtrarlos, editarlos o crear uno nuevo</p>
          </div>

          <div className="d-flex justify-content-between gap-3 mb-4">
            <div className="d-flex gap-3 align-items-center justify-content-between" style={{ width: "40%" }}>
              <form onSubmit={handleSearch} style={{ width: "100%" }}>
                <TextField
                  sx={{
                    fontFamily: "Bricolage Grotesque",
                    '& .MuiInputBase-input-MuiOutlinedInput-input': {
                      fontFamily: "Bricolage Grotesque",
                    },
                    '& label.Mui-focused': {
                      color: '#5656FF',
                      fontFamily: "Bricolage Grotesque"
                    },
                    '& .MuiOutlinedInput-root': {
                      height: "35px",

                      '& fieldset': {
                        borderColor: '#B2BAC2',
                      },
                      '&:hover fieldset': {
                        borderColor: '#5656ff',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#5656ff',
                      },
                    }
                  }}
                  id="exampleSearch"
                  name="q"
                  size="small"
                  placeholder="Buscar evento"
                  type="search"
                  fullWidth
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </form>

              <Select
                id="filtro-eventos"
                IconComponent={() => null}
                value={filtroEventos}
                onChange={(e) => handleFiltroChange(e.target.value)}
                renderValue={(selected) => {
                  const esTodo = selected === "Todo" || !selected;

                  return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IconButton sx={{ p: 0 }}>
                        <FilterList fontSize="small" />
                      </IconButton>
                      <Typography sx={{ fontSize: 14 }}>
                        {esTodo ? (
                          "Filtro"
                        ) : (
                          <>
                            <span style={{ color: "#5656ff", fontWeight: "bold" }}>{selected}</span>
                          </>
                        )}
                      </Typography>
                    </Box>
                  );
                }}
                sx={{
                  '& .MuiSelect-select': {
                    padding: "0 8px",
                    display: 'flex',
                    alignItems: 'center',
                    /* justifyContent: 'center', */
                  },
                  width: "auto",
                  height: '35px',
                  /* minWidth: "110px", */
                  display: "flex",
                  /* justifyContent: "center", */
                  alignItems: "center",
                  outline: 'none',
                  boxShadow: 'none',
                }}
              >
                <MenuItem value="Todo">Todos</MenuItem>
                <MenuItem value="Borrador">Borradores</MenuItem>
                <MenuItem value="Activo">Activos</MenuItem>
                {/* <MenuItem value="Eliminado">Eliminados</MenuItem> */}
                <MenuItem value="Finalizado">Finalizados</MenuItem>
              </Select>

            </div>

            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{ backgroundColor: "#5656FF", color: "#fff" }}
              onClick={handleCrearEvento}
              disabled={validando}
            >
              Crear evento
            </Button>
          </div>

          <TableContainer>
            <Table aria-label="simple table">
              <TableHead sx={{ backgroundColor: "#EDEDED" }}>
                <TableRow>
                  <TableCell>Evento</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Rol</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  data?.length > 0 ? (
                  data.map((evento) => (
                    <TableRow
                      hover
                      key={evento.id}
                      style={{
                          cursor: evento.estado.id === 3 ? 'inherit' : 'pointer'
                      }}
                        onClick={evento.estado.id === 1
                          ? () => handleOpen(evento.id)
                          : evento.estado.id === 3
                          ? null
                          : () => handleRowClick(evento)
                      }
                    >
                      <TableCell scope="row" className="pl-2 ">
                        <div className="d-flex gap-3">
                          <div className="d-flex align-items-center gap-2">
                              <OpenInNew fontSize="small" sx={{ color: "gray" }} />
                            <p className="m-0" style={{ fontSize: "18px" }}>
                              {evento.evento}
                            </p>
                              {evento.privado
                                ?
                                <span style={{ color: '#aeaeae' }}>
                                  <Lock style={{ fontSize: '.8rem' }} />
                                <small>{t("event.private")}</small>
                              </span>
                                :
                                <span style={{ color: '#aeaeae' }}>
                                  <LockOpen style={{ fontSize: '.8rem' }} />
                                <small>{t("event.public")}</small>
                              </span>
                              }
                          </div>
                        </div>
                      </TableCell>
                      <TableCell width={60}>
                          <Chip label={evento.estado?.estado} size="small"
                          sx={{
                            background: colorCirculo(evento.estado.estado)
                              .relleno,
                            color: colorCirculo(evento.estado.estado).texto,
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" width={60}>
                        <div className="d-flex align-items-center gap-1">
                          <CalendarMonthOutlined />
                            <p style={{ marginBottom: "0px", fontSize: "14px" }}>{fechaEventoTexto(evento)}</p>
                        </div>
                      </TableCell>
                      <TableCell align="center" width={100}>
                          <Chip size="small" sx={{ background: "#DADAFF", color: "#3D2EAB" }}
                            avatar={<Avatar sx={{ backgroundColor: "#988EDE" }}><span style={{ color: "#3D2EAB" }}>R</span></Avatar>}
                            label={evento.rol.replace('_', ' ')}
                        />
                      </TableCell>
                      <TableCell scope="row" align="center" width={30}>
                        <IconButton
                          aria-label="see more"
                          id={evento.id}
                          aria-controls={openSeeMore ? "long-menu" : undefined}
                          aria-expanded={openSeeMore ? "true" : undefined}
                          aria-haspopup="true"
                          onClick={handleClickSeeMore}
                          sx={{ color: "black" }}
                        >
                          <MoreVert />
                        </IconButton>
                        <Menu
                          id={evento.id}
                          aria-label="report"
                          anchorEl={anchorEl}
                          open={evento.id == anchorElID}
                          onClose={handleCloseSeeMore}
                          /* anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }} */
                          slotProps={{
                            paper: {
                              elevation: 0,
                              sx: {
                                  overflow: 'visible',
                                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                  '& .MuiAvatar-root': {
                                  width: 32,
                                  height: 32,
                                  ml: -0.5,
                                  mr: 1,
                                },
                                  '&::before': {
                                  content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                  top: 0,
                                  right: 14,
                                  width: 10,
                                  height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                  zIndex: 0,
                                },
                              },
                            },
                          }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            {puedeVerReportes(evento) && (
                            <MenuItem onClick={(e) => HandleDownloadReport(e, evento)}>
                            <ListItemIcon>
                              <InsertChartOutlinedOutlined fontSize="medium" />
                            </ListItemIcon>
                              <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Reporte general</ListItemText>
                          </MenuItem>
                            )}
                            {evento.rol === "Owner" && evento.id_estados_eventos !== 4 && [
                              <Divider key="divider" />,
                              ...(evento.id_estados_eventos === 2 ? [
                                <MenuItem key="finish" onClick={(e) => {
                                        e.stopPropagation();
                                        setEventoToDelete(evento);
                                  setActionType('finish');
                                        setOpenConfirm(true);
                                        handleCloseSeeMore(e);
                                }}>
                                      <ListItemIcon>
                                    <CheckCircleOutline fontSize="medium" sx={{ color: "#5656ff" }} />
                                      </ListItemIcon>
                                  <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Finalizar evento</ListItemText>
                                </MenuItem>
                              ] : []),
                              <MenuItem key="delete" onClick={(e) => {
                                  e.stopPropagation();
                                  setEventoToDelete(evento);
                                setActionType('delete');
                                  setOpenConfirm(true);
                                  handleCloseSeeMore(e);
                              }}>
                                <ListItemIcon>
                                  <DeleteForeverOutlined fontSize="medium" sx={{ color: "#dc2626" }} />
                                </ListItemIcon>
                                <ListItemText sx={{ fontFamily: "Bricolage Grotesque, sans serif" }}>Eliminar evento</ListItemText>
                              </MenuItem>
                            ]}
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Alert severity="info" color="secondary">
                        {filtroEventos !== "Todo"
                          ? `Aún no tienes eventos ${filtroEventos.toLowerCase()}.`
                            : "Aún no tienes eventos."
                          }
                      </Alert>
                    </TableCell>
                  </TableRow>
                  )
                )}
                <MensajeFinalizarCreacionEvento open={open} handleClose={handleClose} eventoId={eventoId} />
              </TableBody>
            </Table>
          </TableContainer>
          {!loading && data?.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", marginTop: "1rem", position: "relative" }}>
              <small>{t("publications.totalEntries")} {totalLength}</small>
              <div style={{ margin: "0 auto" }}>
                <Pagination
                  count={Math.ceil(totalLength / pageSize)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </div>
            </div>
          )}
          <Dialog
            open={openConfirm}
            onClose={() => setOpenConfirm(false)}
            PaperProps={{
              sx: {
                borderRadius: 3,
                minWidth: 340,
                p: 0,
                boxShadow: 6,
              },
            }}
          >
            <Box sx={{ p: 3, textAlign: "center", position: "relative" }}>
              <IconButton
                aria-label="close"
                onClick={() => setOpenConfirm(false)}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 12,
                  color: (theme) => theme.palette.grey[500],
                }}
                size="small"
              >
                ×
              </IconButton>
              <Box
                sx={{
                  background: actionType === 'delete' ? '#FFF0F0' : '#F0FFF4',
                  borderRadius: '50%',
                  width: 56,
                  height: 56,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                }}
              >
                {actionType === 'delete' ? (
                  <DeleteForeverOutlined sx={{ color: '#dc2626', fontSize: 32 }} />
                ) : (
                  <CheckCircleOutline sx={{ color: '#5656ff', fontSize: 32 }} />
                )}
              </Box>
              <h3 style={{ margin: 0, fontWeight: 600 }}>
                {actionType === 'delete'
                  ? '¿Estás seguro que deseas eliminar este evento?'
                  : '¿Estás seguro que deseas finalizar este evento?'}
              </h3>
              <p style={{ color: '#6C757D', marginTop: 8 }}>
                {actionType === 'delete'
                  ? 'Esta acción es permanente.'
                  : 'El evento cambiará al estado finalizado y no se podrán vender más entradas.'}
              </p>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                <Button
                  onClick={() => setOpenConfirm(false)}
                  variant="outlined"
                  sx={{
                    background: '#fff',
                    color: actionType === 'delete' ? '#dc2626' : '#5656ff',
                    borderColor: actionType === 'delete' ? '#dc2626' : '#5656ff',
                    fontWeight: 500,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      background: actionType === 'delete' ? '#fff5f5' : '#f0fff4',
                      borderColor: actionType === 'delete' ? '#dc2626' : '#5656ff'
                    }
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={handleConfirmAction}
                  variant="contained"
                  sx={{
                    background: actionType === 'delete' ? '#dc2626' : '#5656ff',
                    color: '#fff',
                    fontWeight: 500,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      background: actionType === 'delete' ? '#b71c1c' : '#5656ff'
                    }
                  }}
                >
                  {actionType === 'delete' ? 'Eliminar' : 'Finalizar'}
                </Button>
              </Box>
            </Box>
          </Dialog>
        </Container>
      )}
    </>
  );
};
export default withAuthenticationRequired(Evento, {
  onRedirecting: () => <Loading />,
});